import vue from 'vue';
import axios from 'axios';
/*eslint-disable*/
// import qs from 'qs';
// import APIDOC from "./serverApi";
import { getCookie, getStore } from '../../utils/cache';
// import Vuex from "@/vuex";
import Router from "@/router";

// 拦截请求操作
function transformRequest(data, header) {
    //每次请求携带，authorization="token"
    const authorization = getStore("token");
    console.log("获取到的authorization", authorization);
    //获取isWx 统一设置 是否是微信浏览器
    header.common.Authorization = authorization;
    // 做兼容处理， 图片上传的为multipart/form-data
    if (header['Content-Type'] === 'multipart/form-data;charset=UTF-8') {
        return data;
    }
    // return qs.stringify(data);
    return JSON.stringify(data);
}

// 拦截响应操作
function transformResponse(data) {
    // todo
    return data;
}

const instance = axios.create({
    baseUrl: "",
    timeout: 30000,//允许的最大延迟时间
    headers: {
        'Content-Type': 'application/json'
    },
    transformRequest: [transformRequest],
    transformResponse: [transformResponse],
})

const _context = vue.prototype;

//const Version = "?v_n=1.0.1";//请求加上版本号   如：?version=1.0.1
const Version = "";//请求加上版本号   如：?version=1.0.1

// 请求拦截
instance.interceptors.request.use((config) => {
    return config;
},
    (error) => Promise.reject(error));
// 响应拦截
instance.interceptors.response.use((response) => {
    let data = null;
    if (typeof response.data === 'string') {
        data = JSON.parse(response.data);
    } else {
        data = response;
    }

    //对状态码不是200的做统一提示
    const code = data.code;
    if (code == 41009 || code == 43009) {
        // _context.$message({
        //     type: "error",
        //     message: "token失效，请重新登录！"
        // })
        Router.push("/login");
    }
    if (typeof code == 'number' && code != 200) {
        _context.$message({
            type: 'warning',
            message: data.msg
        })
    }
    return Promise.resolve(data);
},
    error => {
        if (error.response) {
            let ret = JSON.parse(error.response.data);
            if (ret.code == 401) {
                _context.$message({
                    message: ret.msg,
                    type: 'warning'
                });
                // setTimeout(function () {
                //     // this.$cookies.remove("JT_S_02_token")
                //     this.$cookies.remove(getCookieKeyForRoleTag());
                //     window.location.href = vue.prototype.$baseUrl;
                //     // localStorage.removeItem('TOKEN');
                //     // window.location.href = window.location.origin;
                // }, 500);
            } else {
                _context.$message({
                    message: ret.msg,
                    type: 'error'
                });
            }
        }
        return Promise.reject(error)
    });

// get 操作
export function get(url, params, option = {}) {
    return new Promise((resolve, reject) => {
        instance.get(url + Version, {
            params,
            ...option,
        }, {
            headers: { "Content-Type": "application/json" }
        })
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}

// post 操作
export function post(url, params, option) {
    return new Promise((resolve, reject) => {
        instance.post(url + Version, params, option)
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}



// WEBPACK FOOTER //
// ./src/api/model/request.js